import React from 'react';
import { Link, useParams } from 'react-router-dom';
import i18n from '../../utils/i18n';
import { withTranslation } from 'react-i18next';

import axios from '../../shared/axios/axiosProxy';
import { withRouter } from '../../withRouter';

const Confirmation = () => {
	const { JWT } = useParams();

	React.useEffect(() => {
		console.log(JWT, 'JWT');
		axios.get(`/api/auth/register/${JWT}`, {}).catch((error) => {
			console.log('AXIOS ERROR: ', error.response.data);
		});
	}, []);

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',

				width: '100%',
			}}>
			<h2
				style={{
					display: 'flex',
					justifyContent: 'center',
					marginTop: '100px',
					width: '100%',
				}}>
				{i18n.t('general.successfulreg')}
			</h2>
			<Link to='/'>
				<button
					style={{
						backgroundColor: '#2d46b9',
						color: 'white',
						border: 'none',
						padding: '10px',
						cursor: 'pointer',
						borderRadius: '5px',
						marginTop: '20px',
					}}>
					{i18n.t('general.login')}
				</button>
			</Link>
		</div>
	);
};

export default withTranslation()(withRouter(Confirmation));
